var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('apexchart',{attrs:{"width":_vm.barChartWidth,"height":"200px","options":_vm.chartOptions,"series":_vm.barChartSeries}})}
var staticRenderFns = []

export { render, staticRenderFns }